import * as SDK from '@replai-platform/sdk';
import * as provider from './provider';

export const getProjects = () => provider.getJson<object, (SDK.Project & any)[]>(`${SDK.BASE_URL()}/projects/all`);
